<template>
  <div class="d-flex so-container">
    <div class="col-6 logo-container" :style="BackgroundColor">
      <div class="big-logo"></div>
      <div class="step-title">
        {{ getSignupHeader }}
      </div>
      <div class="step-desc">{{ getSignupDescription }}</div>
      <div class="logo-powered-by">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <div class="col-6 d-flex justify-content-center">
      <div
        class="form-container shadow-lg"
        style="border-radius: 13px; width: 70%"
      >
        <div
          v-if="step === 2"
          class="w-100 cursor-pointer d-flex flex-row align-items-center justify-content-start"
          @click="step = 1"
        >
          <span class="material-icons md-36">keyboard_arrow_left</span>
          <span>{{ $t("message.back") }}</span>
        </div>
        <div
          v-if="Logo && Logo.length"
          class="big-logo mb-5"
          style="margin-top: -2.5rem"
        >
          <img :src="Logo" alt="logo" @error="imgHttpError" />
        </div>
        <h2 v-else class="w-100 text-center mt-3 mb-3">
          {{ currentStoreDoc.Name }}
        </h2>

        <!--    Enter Otp Form Start    -->
        <form
          v-if="showConfirmation"
          ref="register"
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
        >
          <div class="mt-3 mb-4 d-flex justify-content-center text-center">
            <h4>
              {{ $t("message.enterCodeSentTo") }}
              {{ this.countryCode + this.mobile }}
            </h4>
          </div>

          <div class="w-full">
            <OtpInput
              ref="otpInput"
              :is-input-num="true"
              :num-inputs="6"
              :should-auto-focus="true"
              autocomplete="one-time-code"
              input-classes="otp-input"
              separator="-"
              @on-complete="verifyOtpAndRegisterSoUser"
            />
          </div>

          <div
            class="w-85 mt-4 d-flex align-items-center justify-content-between"
          >
            <span class="font-16">{{
              $t("message.smsResendDescription")
            }}</span>
            <button
              :disabled="!enableResendBtn || loading"
              :style="desktopStyles.LinkColorTxt"
              class="btn btn-link resend-btn font-16"
              type="button"
              @click="resendSms"
            >
              {{ $t("message.smsResendButton") }}
              <span v-show="!enableResendBtn && !loading" class="font-16"
                >({{ resendWait }})</span
              >
            </button>
          </div>

          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
              type="button"
              @click="verifyOtpAndRegisterSoUser(verificationCode)"
            >
              {{ $t("message.confirm") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
        <form
          ref="registerSoUserfrm"
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
          @submit.prevent="goToVerifyCode"
          v-else
        >
          <div class="form-group col-11">
            <label for="Mobile"
              >{{ $t("message.mobile") }}
              <span class="required-logo">*</span></label
            >
            <b-input-group>
              <template #prepend>
                <VueCountryCode
                  @onSelect="selectCountryCode"
                  :preferredCountries="['au', 'us', 'gb']"
                />
              </template>

              <b-form-input
                v-validate="{
                  required: true,
                  min: 8,
                  regex: this.getRegex(),
                  max: this.getMax(),
                }"
                id="Mobile"
                v-model="mobile"
                name="mobile"
                type="text"
                class="form-control"
              >
              </b-form-input>

              <div class="invalid-feedback">
                {{ OOErrors.first("mobile") | inputNameLocale("mobile") }}
              </div>
            </b-input-group>
          </div>

          <div class="form-group col-11">
            <label for="Name"
              >{{ $t("message.name") }}
              <span class="required-logo">*</span></label
            >
            <input
              id="Name"
              v-model="fullName"
              name="name"
              type="text"
              class="form-control"
              v-validate="'min:2'"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}
            </div>
          </div>
          <div class="form-group col-11">
            <label for="Email"
              >{{ $t("message.emailAddress") }}
              <span class="required-logo">*</span></label
            >
            <input
              id="Email"
              v-model="email"
              v-validate="'required|email'"
              type="email"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
              ref="emailAddress"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>

          <div class="form-group col-11">
            <label for="Postcode"
              >{{ $t("message.postcode") }}
              <span class="required-logo">*</span>
            </label>
            <input
              v-validate="'numeric|min:4|max:4'"
              id="Postcode"
              v-model="postcode"
              name="postcode"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
            </div>
          </div>

          <div class="row col-11">
            <div v-show="enableDob" class="form-group col-6 ml-0 pl-0">
              <label for="BirthDate">{{ $t("message.birthDate") }}</label>
              <date-pick
                id="BirthDate"
                name="birthDate"
                v-model="birthDate"
                :format="'DD/MM/YYYY'"
                :inputAttributes="{
                  placeholder: 'DD/MM/YYYY',
                  class: ['form-control', bdstatus],
                }"
                @input="isValidDate($event)"
                :parseDate="parseDate"
                :startPeriod="{ month: 0, year: 1990 }"
              ></date-pick>
              <span
                v-if="birthDatestatus == 2"
                class="invalid-feedback"
                style="display: block"
              >
                {{
                  birthDatestatus == 1
                    ? $t("message.birthDateRequire")
                    : "The Date of Birth should be DD/MM/YYYY format"
                }}
              </span>
              <div class="invalid-feedback">
                {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
              </div>
            </div>
            <div v-show="enableGender" class="form-group col-6 mr-0 pr-0">
              <label for="Gender">{{ $t("message.gender") }}</label>
              <vselect
                :options="genderOptions"
                :searchable="false"
                :clearable="false"
                v-model="gender"
                label="text"
                value="id"
              >
                <template slot="option" slot-scope="option">
                  {{ option.text }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.text }}
                </template>
              </vselect>
            </div>
          </div>

          <div
            class="form-group col-11"
            v-if="enablePreferredStore"
          >
            <label for="PreferredStore">{{
              $t("message.preferredStore")
            }}</label>
            <vselect
              :options="preferredStoreOptions"
              :searchable="false"
              :clearable="false"
              v-model="preferredStore"
              label="Name"
              value="ID"
            >
              <template slot="option" slot-scope="option">
                {{ option.Name }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.Name }}
              </template>
            </vselect>
          </div>

          <div
            class="form-group mt-4 justify-content-left d-flex ml-0 pl-0 col-10"
          >
            <Checkbox :label="''" v-model="agree" :IsRadio="false"></Checkbox>
            <p class="agree-container">
              {{ $t("message.agreeSoRegister") + currentStoreDoc.Name }}
            </p>
          </div>

          <div class="form-group mt-3">
            <button
              :disabled="loading || !agree"
              :style="desktopStyles.btn"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-around fs-19 fw-600"
              style="border-radius: 8px"
              type="submit"
            >
              <span class="ml-3" v-show="!loading"></span>
              <span class="ml-5">{{ $t("message.joinMembership") }}</span>
              <span class="material-icons md-36 pl-5 font-31" v-show="!loading"
                >keyboard_arrow_right</span
              >
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
          <div
            class="form-group mt-3 justify-content-center"
            @click.prevent="showModal = true"
          >
            <p
              v-html="$t('message.termsOfUsePrivacyStatement')"
              style="font-size: 12px; line-height: 1.4"
            ></p>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
        <!-- Enter Details Form end-->
      </div>
    </div>
    <progressindicator
      v-if="showProgress"
      style="opacity: 0.4"
    ></progressindicator>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal" />
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/register.js";
import login from "../../sharedscripts/user/login.js";
import { getStoreByHqID } from "../../api/services/storeService.js";
import { wcconfig } from "../../../wcConfig";
import { mapGetters, mapActions } from "vuex";
import vselect from "vue-select";
import DatePick from "vue-date-pick";
import progressindicator from "../progressindicator";
import Checkbox from "../shared/checkbox";
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";
import OtpInput from "@bachdgvn/vue-otp-input";
import VueCountryCode from "vue-country-code";

export default {
  components: {
    vselect,
    DatePick,
    progressindicator,
    Checkbox,
    termsAndConditionsModal,
    OtpInput,
    VueCountryCode,
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      verificationCode: "",

      success: true,
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      mobile: "",
      postcode: "",
      birthDate: "",
      loading: false,
      showProgress: false,
      error: "",
      logoUrl: "",
      birthDatestatus: 0,
      genderOptions: [
        { id: true, text: "Male" },
        { id: false, text: "Female" },
        { id: null, text: "Unspecified" },
      ],
      gender: null,
      preferredStoreOptions: [],
      preferredStore: null,
      agree: false,
      showModal: false,

      // step 1 displays form
      // step 2 displays OTP input for phone number auth
      step: 1,
      resendWait: 30, //seconds
      appVerifier: "",
      otp: "",
      countryCode: "+61",
      showSuccess: function (msg) {
        this.makeToast("Success", msg, "success");
      },
      showError: function (msg) {
        this.makeToast("Internal Error", msg, "danger");
      },
    };
  },
  computed: {
    showConfirmation() {
      return this.step == 2;
    },
    ...shared.computed,
    ...mapGetters([
      "desktopStyles",
      "viewConfig",
      "currentStoreDoc",
      "getStoreWalletDoc",
      "getStoreColor",
    ]),
    bdstatus() {
      return this.birthDatestatus == 2 ? "invaliddatetime" : "";
    },
    Logo() {
      if (this.currentStoreDoc && this.currentStoreDoc.Logo) {
        return this.currentStoreDoc.Logo;
      }
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    BackgroundColor() {
      let styles = [];
      let colour = "#3994ff";
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.Colours &&
        this.currentStoreDoc.ThemeSettings.Colours.IntroBackground
      ) {
        colour = this.currentStoreDoc.ThemeSettings.Colours.IntroBackground;
      }

      styles.push({ "background-color": `${colour}` });
      return styles;
    },
    fullName: {
      get() {
        if (!this.lastName.length) {
          return this.firstName;
        }
        return this.firstName + " " + this.lastName;
      },
      set(val) {
        if (!val) return;
        const [firstName, ...lastName] = val.split(" ").filter(Boolean);
        this.firstName = firstName;
        this.lastName = lastName.join(" ");
      },
    },
    storeGeneralConfiguration() {
      if (
        !this.getStoreWalletDoc ||
        !this.getStoreWalletDoc.GeneralConfiguration
      ) {
        return null;
      }

      return this.getStoreWalletDoc.GeneralConfiguration;
    },
    storeThemeConfiguration() {
      if (
        !this.getStoreWalletDoc ||
        !this.getStoreWalletDoc.ThemeConfiguration
      ) {
        return null;
      }

      return this.getStoreWalletDoc.ThemeConfiguration;
    },

    enableDob() {
      return (
        this.storeGeneralConfiguration &&
        this.storeGeneralConfiguration.EnableDob
      );
    },

    enableGender() {
      return (
        this.storeGeneralConfiguration &&
        this.storeGeneralConfiguration.EnableGender
      );
    },

    enablePreferredStore() {
      return (
        this.storeGeneralConfiguration &&
        this.storeGeneralConfiguration.EnablePreferredStore
      );
    },

    getSignupHeader() {
      if (!this.storeGeneralConfiguration)
        return this.$t("message.soRegisterLastStepMessage");
      return (
        this.storeGeneralConfiguration.SignUpHeader ||
        this.$t("message.soRegisterLastStepMessage")
      );
    },
    getSignupDescription() {
      if (!this.storeGeneralConfiguration)
        return this.$t("message.soRegisterLastStepDesc");
      return (
        this.storeGeneralConfiguration.SignUpText ||
        this.$t("message.soRegisterLastStepDesc")
      );
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  mounted() {
    const self = this;
    this.showProgress = true;
    this.setStore(this.storeid);

    this.initStoreWallet(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
        self.setStoreLoaded();
      },
    });
    this.initReCaptcha();
  },
  methods: {
    closeDialog() {
      this.step = 1;
    },
    ...mapActions(["initStore", "initStoreWallet"]),
    makeToast(title, msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
    closeModal() {
      this.showModal = false;
    },
    parseDate(dateString) {
      var date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    async goToVerifyCode() {
      await this.sendLoyaltyOtp();
    },

    selectCountryCode(value) {
      this.countryCode = `+${value.dialCode}`;
    },

    ...shared.methods,
    ...login.methods,
  },
  watch: {
    currentStoreDoc(newStore) {
      if (newStore.HQCompanyID != newStore.ID || newStore.IsHQ) {
        if (!this.loading) {
          var that = this;
          that.showProgress = true;
          that.loading = true;
          getStoreByHqID(newStore.HQCompanyID)
            .get()
            .then(function (snapshot) {
              that.loading = false;
              that.showProgress = false;
              that.preferredStoreOptions = [];
              snapshot.docs.forEach(function (doc) {
                var item = doc.data();
                if (item.ID != newStore.HQCompanyID)
                  that.preferredStoreOptions.push(item);
              });
            })
            .catch(() => {
              that.showProgress = false;
              that.loading = false;
            });
        }
      } else {
        this.showProgress = false;
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.otp-input {
  width: 2rem;
  height: 2rem;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.required-logo {
  color: red;
}
.vdpComponent {
  display: block;
}
.centered {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}
.so-container {
  min-height: 100vh;
  .logo-container {
    background: #3994ff 0% 0% no-repeat padding-box;
    opacity: 0.95;
    .step-title {
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      margin-top: 130px;
      margin-left: 40%;
    }

    .step-desc {
      width: 50%;
      font-size: 16px;
      color: #ffffff;
      margin-top: 30px;
      margin-left: 40%;
    }

    .logo-powered-by {
      width: 50%;
      font-size: 11px;
      color: #ffffff;
      margin-top: 70px;
      margin-left: 40%;
    }

    .abacus-logo {
      margin-left: 40%;
      height: 26px;
      width: 143px;
      background: transparent url("./../../assets/abacus-logo-white.png") 0% 0%
        no-repeat padding-box;
      opacity: 1;
      background-size: contain;
    }

    .big-logo {
      margin-top: 15%;
      margin-left: 40%;
      max-height: 158px;
      max-width: 159px;
      img {
        height: 100%;
        width: 100%;
        background: transparent 0% 0% no-repeat padding-box;
        opacity: 1;
        background-size: contain;
      }
    }
  }
}

.oo-module {
  .form-container {
    padding: 20px 0;
    width: 440px;
    background-color: #ffffff;
    margin-top: 10%;
    margin-bottom: 3%;

    .form-group {
      width: 374px;
      margin-bottom: 0.2rem;
      .checkbox-label {
        left: 0;
      }
      span.checkbox-checkmark {
        left: 0px !important;
      }
      p.agree-container {
        position: relative;
        left: -20px;
        text-align: left;
        font-size: 0.6875rem;
        line-height: 1.4;
        text-align: left;
      }
      label {
        font-size: 0.8rem;
        margin-bottom: 0.1rem;
      }

      .form-control,
      .dropdown-toggle {
        border-radius: 0px;
      }
    }
  }
}

.b-toast-success.b-toast-solid,
.b-toast-danger.b-toast-solid {
  .toast {
    flex-basis: 350px;
    font-size: 0.875rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    .toast-header {
      padding: 0.45rem 0.85rem;
    }
    .toast-body {
      padding: 0.75rem;
    }
  }
}
</style>
